import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCancelledCancellation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.994 1c1.572.177 4.521 2.648 4.521 2.648 1.256.964 2.746 1.516 4.468 1.658.273 7.068-2.69 12.475-8.892 17.264 0 0-.109.049-.182 0-6.201-4.789-9.165-10.196-8.892-17.264 1.64-.135 3.07-.642 4.287-1.523 0 0 3.046-2.597 4.7-2.783h-.01Z"
      fill="url(#cancelled-cancellation_svg__a)"
    />
    <path d="m15.125 8.875-6.25 6.25m6.25 0-6.25-6.25" stroke="#fff" />
    <defs>
      <linearGradient
        id="cancelled-cancellation_svg__a"
        x1={3}
        y1={1}
        x2={24.841}
        y2={17.511}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7F08" />
        <stop offset={0.52} stopColor="#FA4668" />
        <stop offset={1} stopColor="#E067AE" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgCancelledCancellation);
export default Memo;
